export const BOARD_SOCKET_EVENTS = {
  // client -> server
  funnelSubscribe: 'board-v3:funnel:subscribe',
  funnelUnsubscribe: 'board-v3:funnel:unsubscribe',
  cardSubscribe: 'board-v3:card:subscribe',
  cardUnsubscribe: 'board-v3:card:unsubscribe',
  presencePing: 'board-v3:presence:ping',
  cardPresencePing: 'board-v3:card:presence:ping',

  // server -> client
  presencePong: 'board-v3:presence:pong',
  cardPresencePong: 'board-v3:card:presence:pong',
  cardPresence: 'board-v3:card:presence',
  funnelPresence: 'board-v3:funnel:presence',
  funnelCreate: 'board-v3:funnel:create',
  funnelUpdate: 'board-v3:funnel:update',
  funnelDelete: 'board-v3:funnel:delete',
  cardCreate: 'board-v3:card:create',
  cardUpdate: 'board-v3:card:update',
  cardDetailUpdate: 'board-v3:card:detail:update',
  cardDelete: 'board-v3:card:delete',
  cardTimelineEvent: 'board-v3:card:timeline-event',
  funnelColumnsUpdate: 'board-v3:funnel:columns-update',
  funnelFieldsUpdate: 'board-v3:funnel:fields-update',
  funnelImportProgress: 'board-v3:funnel:import-progress',
  funnelExportProgress: 'board-v3:funnel:export-progress',
  leadConversionResult: 'board-v3:lead-conversion:result',
} as const;
